import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ImgDownload from "../images/Image_download.png";
import ExcelImg from "../images/excel.png";
import { useRef } from"react"
import "./Table.css"


import * as XLSX from 'xlsx'
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';


//Return table
export default function BasicTable({props, year, excelData}) {

  
  const tableRef = useRef(null);

  const handleImgDownload = () => {
    html2canvas(tableRef.current).then((canvas) => {
      canvas.toBlob((blob) => {
        saveAs(blob, 'table.png');
      });
    });
  };


const handleDownload = () => {
  console.log(excelData)
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, "data.xlsx");
};


  return (
    <div>
        <nav className="navbar navbar-expand-sm" id = "buttons-nav">
            <ul className ="navbar-nav ml-auto">
                <li className="nav-item">
                    <button onClick = {handleImgDownload} className="navbar-brand buttons" >
                        <img src= {ImgDownload} width="20" height="20" alt="Download"  border = "0" />
                    </button>
                </li>
                <li className="nav-item">
                    <button onClick = {handleDownload} className="navbar-brand buttons" >
                        <img src= {ExcelImg} width="20" height="20" alt="Download Excel"/>
                    </button>
                </li>
            </ul>
        </nav>
      <div>
        <TableContainer component={Paper} ref={tableRef}>
          <Table sx={{ minWidth: 100}} aria-label="simple table">
            <TableHead>
              <TableRow id = "firstRow" className= "row">
                <TableCell className = "tablecells"><b>Επιβάτες</b></TableCell>
                <TableCell className = "tablecells" align="right"><b>{year - 1} <br></br>(εκατομμύρια)</b></TableCell>
                <TableCell className = "tablecells" align="right"><b>{year} <br></br>(εκατομμύρια)</b></TableCell>
                <TableCell className = "tablecells" align="right"><b>Διαφορά <br></br>(%)</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.map((row) => (
                <TableRow
                  key={row.name}
                  className = "row"
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell className = "tablecells" component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell className = "tablecells"  align="right">{row.firstYear}</TableCell>
                  <TableCell className = "tablecells" align="right">{row.secondYear}</TableCell>
                  <TableCell className = "tablecells" align="right">{row.difference}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}